import {createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {CheckoutItemsType, OrderReviewType} from 'desktop/types/checkoutItemsType';
import {apiConfig} from 'libs/api/api';

export const initialState: OrderReviewType = {
    list: [],
    status: '',
};

// TODO GUSA-49355 This is excess action
// use getTotals from src/mobile/pages/checkout/store/actions/checkout.ts
export const getOrderReviewItems = createAsyncThunk<
    {data: CheckoutItemsType},
    {collectTax: boolean; withTaxErrors: boolean}
>('CHECKOUT@GET_ORDER_REVIEW_ITEMS', ({collectTax = true, withTaxErrors = true}) =>
    apiConfig.instanceGusaBackend({
        method: 'get',
        params: {collectTax: collectTax ? 1 : 0, withTaxErrors: withTaxErrors ? 1 : 0},
        url: `${ENDPOINTS.CHECKOUT_GET_ITEMS_V2}`,
    }),
);

/**
 * Order review items
 * @param {OrderReviewType} state - reducer state
 * @return {OrderReviewType} - new state
 */
export const orderReviewItems = createReducer(initialState, builder =>
    builder.addCase(getOrderReviewItems.fulfilled, (state, action) => ({
        ...state,
        list: action.payload.data,
        status: 'FULFILLED',
    })),
);
